import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { SecureStorage } from 'projects/Autofacets-Core/src/app/common-services/SecureStorage.service';

@Component({
  selector: 'app-term-n-condition',
  templateUrl: './term-n-condition.component.html'
})
export class TermNConditionComponent implements OnInit {

  constructor(
    public activeModal: NgbActiveModal,
    private secureStorage: SecureStorage,
    private translate: TranslateService
  ) { }
  privacyConsent: string;
  ngOnInit(): void {
    this.privacyConsent=this.secureStorage.getKeyData('TermsConditionData');
  }

 

}
